import { getDateDaysFromNow } from '@develop/ia-utils'

/**
   * Ensure chosen pharmacy is set to cookie
   * Ensure chosen pharmacy is set to user pharmacy
   * @param pharmacyId chosen pharmacy id
   */
export const ensureCookieAndUserPharmacy = async (pharmacyId: number) => {
  const userStore = useUserStore()
  const authStore = useAuthStore()

  const cookieMatchesPharmacy = userStore.getPharmacyCookie() === pharmacyId
  if (!cookieMatchesPharmacy)
    userStore.setPharmacyCookie(pharmacyId, { expires: getDateDaysFromNow(1) })

  if (authStore.isAuthenticated && userStore.userPharmacyId !== pharmacyId)
    await userStore.updateUserPharmacy(pharmacyId, { refetchUser: true })
}
